import React from "react";
import '@/styles/loader.css';

/**
 * A Loader React component
 * @param {*} props A list of HTML properties
 */
export default function Loader({className, ...props}) {
  return (
    <div className={`loader ${className}`} {...props}></div>
  );
}